import { render, staticRenderFns } from "./TopArticlesChart.vue?vue&type=template&id=9e9c2740&"
import script from "./TopArticlesChart.vue?vue&type=script&lang=js&"
export * from "./TopArticlesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports